import Select from "components/input-types/Select";
import { useSelector } from "react-redux";
import { selectAssetRc } from "./assetRcSlice";

const AssetRc = (props) => {
	const lookup = useSelector(selectAssetRc);
	const mappedLookup = lookup.map((l) => {
		const { id, code } = l;
		return { id, code, description: code };
	});
	return <Select {...props} lookup={mappedLookup} />;
};

export default AssetRc;
